<template>
  <div class="ui-accordion">
    <div class="ui-accordion__select" @click="$emit('input', !value)">
      <div class="ui-accordion__label"> {{ label }} </div>
      <div class="ui-accordion__point">
        <accordion-icon :top="value" :bottom="!value" />
      </div>
    </div>
    <div v-if="value" class="ui-accordion__content">
      <slot />
    </div>
  </div>
</template>

<script>
import AccordionIcon from '@/components/icons/PanoramaAccordionIcon'
export default {
  name: 'PanoramaUiAccordion',
  components: {
    AccordionIcon
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-accordion {
  background: var(--panorama-background-color);
  border-radius: 3px;
  padding: 4px 5px 4px 8px;
  user-select: none;
  width: 130px;
  @media screen and (min-width: 768px) {
    width: 171px;
  }
  @media screen and (min-width: 1920px) {
    width: 9vw;
    padding: 0.23% 0.27% 0.21% 0.45%;
    border-radius: 0.16vw;
  }
  &__select {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__label {
    font-family: var(--panorama-first-font);
    font-weight: bold;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--panorama-text-color);
    @media screen and (min-width: 1920px) {
      font-size: 0.62vw;
    }
  }
  &__content {
    padding-top: 10px;
    @media screen and (min-width: 1920px) {
      padding-top: 0.55vw;
    }
  }
}

</style>
